// This is used on the file src/util/operations/index.js
// It is used to render the company policy conditionally
export const SUPPORTED_LOGICAL_OPERATORS = ["$and", "$or"];

export const SUPPORTED_COMPARISONS_OPERATORS = [
    "$eq",
    "$ne",
    "$gte",
    "$lte",
    "$gt",
    "$lt",
    "$exists",
    "$notExists",
    "$in",
    "$elemMatch"
];

// no of expressions supported for each operator
export const COMPARISON_OPERATORS_SUPPORTED_VALUES_LENGTH = {
    "$eq": 2,
    "$ne": 2,
    "$gte": 2,
    "$lte": 2,
    "$gt": 2,
    "$lt": 2,
    "$exists": 1,
    "$notExists": 1,
    "$in": 2,
    "$elemMatch": 3
};